import en from './locales/en.json';
import zh from './locales/zh.json';

const messages = {
  en,
  zh,
};

const langCode2Name = {
  en: 'English',
  zh: '简体中文',
};

export default {
  messages,
  langCode2Name,
};
